<template>
    <div id="stardoc">
        <div class="page_header">
            <div class="header_title"><img class="header_icon" src="./img/img_icon_13.png" alt="">回收站</div>
            <div class="header_right">
                <!-- <div v-show="multipleSelection.length" @click="removeAll('delete')" class="header_btn remove_btn"><img class="header_icon" src="./img/img_icon_68.png" alt="">彻底删除</div> -->
                <!-- <div @click="removeAll('restore')" class="header_btn"><img class="header_icon" src="./img/img_icon_02.png" alt="">恢复文件</div> -->
                <el-input size="small" class="search_input" placeholder="请输入关键字" suffix-icon="el-icon-search" v-model="searchVal" @keyup.enter.native="searchData"></el-input>
            </div>
        </div>
        <div class="page_content">
            <el-scrollbar class="write_scrollbar">
                <el-table class="doc_table" :data="tableData" style="width: 100%" @selection-change="handleSelectionChange"  v-if="total">
                    <!-- <el-table-column type="selection" width="40"></el-table-column> -->
                    <el-table-column label="文档名称" :show-overflow-tooltip="true">
                        <template slot-scope="scope">
                            <div class="doc_name">
                                <router-link :to="'/longwriting?tplid='+scope.row.template_id+'&artid='+scope.row.id" v-if="scope.row.template_id ==27">
                                    <img class="table_icon" src="./img/img_icon_30.png" alt="">{{ scope.row.question }}
                                </router-link>
                                <router-link :to="'/essaywriting?tplid='+scope.row.template_id+'&artid='+scope.row.id" v-else>
                                    <img class="table_icon" src="./img/img_icon_30.png" alt="">{{ scope.row.question }}
                                </router-link>
                                <img class="nav_icon" src="./img/star.png" v-if=" scope.row.is_star">
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="model_type" label="应用模版" width="240">
                        <template slot-scope="scope">
                            <img class="table_icon" :src="scope.row.app_icon" alt="">{{ scope.row.app_name }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="real_name" label="创作作者" width="150">
                        <template slot-scope="scope">
                            <span style="color: #999;">{{ scope.row.real_name }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="update_time" label="最近打开时间" width="200">
                        <template slot-scope="scope">
                            <span style="color: #999;">{{ scope.row.update_time }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="40" align="center">
                        <template slot-scope="scope">
                            <el-popover placement="left-start" :offset="10" width="280" trigger="click" @after-leave="popHide(scope.row)">
                                <div class="more_menu" v-show="!scope.row.show">
                                    <div class="menu_group">
                                        <div class="menu_item" @click="doActionRow(scope.row, 'delete')" style="color:#cc0000;"><img class="menu_icon" src="./img/img_icon_68.png" alt="">彻底删除</div>
                                    </div>
                                    <div class="menu_group">
                                        <div class="menu_item" @click="doActionRow(scope.row, 'restore')"><img class="menu_icon" src="./img/img_icon_681.png" alt="">恢复文件</div>
                                    </div>
                                </div>
                                <img class="table_icon more_icon" slot="reference" src="./img/img_icon_69.png" alt="">
                            </el-popover>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pagination_wrap" v-if="total">
                    <el-pagination background @size-change="handleSizeChange" @current-change="handlePageChange" :page-sizes=[10,15,50,100] :page-size="page_size" layout="prev, pager, next, sizes" prev-text="上一页" next-text="下一页" :current-page="page" :total="total"></el-pagination>
                </div>
                <div  v-if="total==0" class="kong">
                    <router-link active-class="active" exact class="nav_item" to="/essaywriting?tplid=19&m=a">
                        <img src="./img/kong.png">
                        <div class="write">无文档，去创作 →</div>
                    </router-link>
                </div>
            </el-scrollbar>
        </div>
    </div>
</template>
<script type="text/ecmascript-6">
    export default {
        data() {
            return {
                searchVal:"",
                tableData:[],
                multipleSelection:[],
                page:1,
                page_size:10,
                total:0
            }
        },
        created() {
            this.fetchArticleList();
        },
        methods: {
            handleSelectionChange(val){
                this.multipleSelection = val;
            },
            searchData(){
                this.page = 1;
                this.fetchArticleList()
            },
            handlePageChange(val){
                this.page = val;
                this.fetchArticleList();
            },
            handleSizeChange(size){
                this.page_size = size;
                this.fetchArticleList()
            },
            fetchArticleList(){
                // 最近文档
                this.$http.get(`/front/aixz/recycle/`,{params:{page:this.page, question:this.searchVal, page_size:this.page_size}}).then(res =>{
                    if(res.status=='200'){
                        this.total =  res.data.total;
                        this.tableData = res.data.item_list.map(item=>{
                            item.show = false;
                            return item
                        })
                    }
                })
            },
            doActionRow(row, action){
                // 单行操作
                if(action=="restore"){
                    this.$http.patch(`/front/aixz/recycle/${row.id}/`,{action:action}).then(res =>{
                        if(res.status=='200'){
                            this.$message({
                                message: '操作成功',
                                type: 'success',
                                duration:1500
                            });
                            this.fetchArticleList()
                        }
                    })
                }
               
                if(action=="delete"){
                    this.$confirm('此操作将彻底删除该文档, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'error'
                    }).then(() => {
                        this.$http.patch(`/front/aixz/recycle/${row.id}/`,{action:action}).then(res =>{
                            if(res.status=='200'){
                                this.$message({
                                    message: '操作成功',
                                    type: 'success',
                                    duration:1500
                                });
                                this.fetchArticleList()
                            }
                        })
                    }).catch(() => {});
                }
            },
            removeAll(action){
                if(!this.multipleSelection.length){
                    this.$message({
                        message: '请先选择文档',
                        type: 'warning',
                        duration:1500
                    });
                }else{
                    let msg = "此操作将恢复选中的文档, 是否继续?"
                    if(action == "delete"){
                        msg = "此操作将彻底删除选中的文档, 是否继续?"
                    }
                    this.$confirm(msg, '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'error'
                    }).then(() => {
                        let value = ""
                        this.multipleSelection.forEach(e => {
                            if(value==""){
                                value = e.id
                            }else{
                                value += "," + e.id
                            }
                        })
                        this.$http.patch(`/front/aixz/recycle/`,{action:action, value:value}).then(res =>{
                            if(res.status=='200'){
                                this.$message({
                                    message: '操作成功',
                                    type: 'success',
                                    duration:1500
                                });
                                this.fetchArticleList()
                            }
                        })
                    }).catch(() => {});
                }
            },
            popHide(data){
                data.show =false;
            }
        },
    }
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    #stardoc{
        height: 100%;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        padding: 0 20px;
        .page_header{
            height: 57px;
            display: flex;
            align-items: center;
            line-height: 56px;
            border-bottom: 1px solid #e5e5e5;
            margin-right: 20px;
            .header_icon{
                width: 16px;
                vertical-align: middle;
                margin: -2px 8px 0 0;
            }
            .header_title{
                flex-grow: 1;
            }
            .header_right{
                display: flex;
                align-items: center;
                .header_btn{
                    margin-right: 26px;
                    cursor: pointer;
                    &.remove_btn{
                        color: #cc0000;
                    }
                }
                .search_input{
                    width: 480px;
                }
            }
        }
        .page_content{
            flex-grow: 1;
            overflow: hidden;
            .kong{
                text-align: center;
                cursor: pointer;
                .write{color: #ccc;}
                img{
                    height: 150px;
                }
            }
            .doc_table{
                background-color: transparent;
                /deep/ tr{
                    background-color: transparent;
                    .el-table__cell{ 
                        padding: 17px 0;
                        border-color: #eee;
                        .cell{
                            padding: 0;
                        }
                    }
                }
                .doc_name{
                    display: flex;
                    align-items: center;
                    a{
                        overflow:hidden;
                        text-overflow:ellipsis;
                    }
                }
                .nav_icon{
                    width: 15px;
                    height: 15px;
                    margin-left: 5px;
                }
                .table_icon{
                    width: 16px;
                    margin-right: 8px;
                    vertical-align: middle;
                    margin-top: -2px;
                    &.more_icon{
                        margin-right: 4px;
                    }
                }
            }
            .more_icon{
                cursor: pointer;
            }
            .pagination_wrap{
                text-align: center;
                margin-top: 25px;
            }
        }
    }
    .more_menu{
        padding: 0 15px;
        .menu_group{
            padding: 10px 0;
            border-bottom: 1px dashed #ccc;
            &:last-child{
                border-bottom: none;
            }
            .menu_item{
                line-height: 42px;
                cursor: pointer;
                position: relative;
                padding-left: 16px;
                &:hover{
                    background-color: #eee;
                }
                .menu_icon{
                    width: 16px;
                    vertical-align: middle;
                    margin: -2px 16px 0 0;
                }
                .right_icon{
                    width: 20px;
                    margin: 0;
                    position: absolute;
                    top: 11px;
                    right: -7px;
                }
            }
        }
    }
</style>